import React, { Component } from 'react';
import Events from './events';

export default class BackgroundRefresher extends Component {

    componentWillMount() {

        window.addEventListener('visibilitychange', this.onVisibilityChange);
        window.addEventListener('focus', this.onWindowFocus);
        window.addEventListener('blur', this.onWindowBlur);

        this.appBackgroundTimeout = 10000;
        this.tabLastFocusedTime = Date.now();
    }

    componentWillUnmount() {

        window.removeEventListener('focus', this.onWindowFocus);
        window.removeEventListener('blur', this.onWindowBlur);
    }

    onVisibilityChange = (e) => {

        // console.log('window visibilitychange', e, document.visibilityState);
        if (document.visibilityState === 'visible') {
            this.onWindowFocus(e);
        } else if (document.visibilityState === 'hidden') {
            this.onWindowBlur(e);
        }
    }

    onWindowFocus = (e) => {

        document.dispatchEvent(new CustomEvent(Events.UNPAUSE_DFAST));

        var timeUnfocused = Date.now() - this.tabLastFocusedTime;
        if (timeUnfocused >= this.appBackgroundTimeout && document.hasFocus() && !this.props.tripSharing) {
            /* Send an event to perform dashboard query */
            document.dispatchEvent(new CustomEvent(Events.REFRESH_RAVEN));
            document.dispatchEvent(Events.refreshAllRavens());
        }
    }

    onWindowBlur = (e) => {

        document.dispatchEvent(new CustomEvent(Events.PAUSE_DFAST));
    }

    render() {

        return null;
    }
}
